__turbopack_context__.v({
  "blocksBackgroundColor": "HeaderShortcuts-module-scss-module__yLEiZa__blocksBackgroundColor",
  "blocksFontColor": "HeaderShortcuts-module-scss-module__yLEiZa__blocksFontColor",
  "container": "HeaderShortcuts-module-scss-module__yLEiZa__container",
  "dragSource": "HeaderShortcuts-module-scss-module__yLEiZa__dragSource",
  "draggable": "HeaderShortcuts-module-scss-module__yLEiZa__draggable",
  "icon": "HeaderShortcuts-module-scss-module__yLEiZa__icon",
  "popup": "HeaderShortcuts-module-scss-module__yLEiZa__popup",
  "popupTitle": "HeaderShortcuts-module-scss-module__yLEiZa__popupTitle",
  "reorder": "HeaderShortcuts-module-scss-module__yLEiZa__reorder",
  "secondaryNavBackgroundColor": "HeaderShortcuts-module-scss-module__yLEiZa__secondaryNavBackgroundColor",
  "shortcutContainer": "HeaderShortcuts-module-scss-module__yLEiZa__shortcutContainer",
  "themeBackgroundColor": "HeaderShortcuts-module-scss-module__yLEiZa__themeBackgroundColor",
  "themeFontColor": "HeaderShortcuts-module-scss-module__yLEiZa__themeFontColor",
  "themeFontFamily": "HeaderShortcuts-module-scss-module__yLEiZa__themeFontFamily",
});
